import { Component } from 'react';
import ReactDOM from 'react-dom';
import _ from 'lodash';
import classNames from 'classnames';
import { Menu } from './Menu';
import { Select } from './Select';
import styles from './SelectWithSearch.module.css';

export class SelectWithSearch extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedValue: '',
            searchTerm: '',
            isFocused: false,
            isOpen: false,
            isSearching: true,
            isSelected: false,
            searchTermChange: false
        };
    }

    componentDidMount() {
        const { selectedLabel, items, value } = this.props;
        const selectedItem = _.find(items, { value });
        const selectedValue = selectedItem ? selectedItem.label : selectedLabel;

        if (selectedValue) {
            this.setState({
                selectedValue,
                isSearching: false,
                isSelected: true
            });
        }
    }

    handleClick = () => {
        if (this.state.selectedValue) {
            this.setState(
                {
                    isSearching: true,
                    isSelected: false
                },
                this.focus
            );
        }
    };

    focus = () => {
        // eslint-disable-next-line react/no-string-refs,react/no-find-dom-node
        let input = ReactDOM.findDOMNode(this.refs.input);
        input.querySelector('input') && input.querySelector('input').focus();
    };

    blur = () => {
        // eslint-disable-next-line react/no-string-refs,react/no-find-dom-node
        let input = ReactDOM.findDOMNode(this.refs.input);
        input.querySelector('input');
    };

    handleInputFocus = () => {
        this.setState({
            isFocused: true,
            isOpen: true
        });
    };

    handleInputBlur = () => {
        if (this.state.selectedValue) {
            this.setState({
                isFocused: false,
                isOpen: false,
                isSearching: false,
                isSelected: true
            });

            return;
        }

        this.setState({
            isFocused: false,
            isOpen: false
        });
    };

    onKeyDown = (e) => {
        if (e.which === 13 || e.which === 9) {
            e.preventDefault();
            this.props.onButtonClick(this.state.searchTerm);
            this.openDropdown();
        }
    };

    onChange = (searchTerm) => {
        this.setState({
            searchTermChange: true
        });
        this.props.onChange(searchTerm);
        this.resetField(searchTerm);
    };

    resetField(searchTerm) {
        const shouldFieldReset = !searchTerm && this.state.selectedValue;

        if (shouldFieldReset) {
            this.setState({
                selectedValue: '',
                searchTerm,
                isSelected: false
            });
            this.props.onSelect && this.props.onSelect(null);
        } else {
            this.setState({
                searchTerm
            });
        }
    }

    onIconClick = () => {
        this.props.onButtonClick(this.state.searchTerm);
        this.openDropdown();
    };

    openDropdown() {
        this.setState({
            isFocused: true,
            isOpen: true
        });
    }

    selectItem = (item) => {
        if (this.props.onSelect) {
            this.props.onSelect(item);
        }

        this.setState(
            {
                selectedValue: item.label,
                isSearching: false,
                isSelected: true,
                isOpen: false,
                isFocused: false
            },
            this.blur
        );
    };

    handleMouseDownOnMenu(e) {
        e.stopPropagation();
        e.preventDefault();
    }

    render() {
        const selectStyle = classNames(
            styles.SelectWithSearch,
            this.props.className,
            {
                'has-focus': this.state.isFocused,
                [this.props.focusedClassName]:
                    this.state.isFocused && this.props.hasMoreThanFourResults
            }
        );

        const {
            placeholder,
            formatter,
            isLoading,
            items,
            optionRenderer,
            helperText,
            switchPosition,
            manualSwitchText,
            noResultsRenderer,
            noSearchTermRenderer,
            manualSwitch,
            isSuccess,
            warningRenderer
        } = this.props;

        return (
            <div
                className={selectStyle}
                data-testid={this.props['data-testid']}
            >
                <Select
                    // eslint-disable-next-line react/no-string-refs
                    ref="input"
                    isLoading={isLoading}
                    onClick={this.onIconClick}
                    onFocus={this.handleInputFocus}
                    onBlur={this.handleInputBlur}
                    onChange={this.onChange}
                    onKeyDown={this.onKeyDown}
                    handleClick={this.handleClick}
                    value={
                        this.state.isSelected
                            ? this.state.selectedValue
                            : this.state.searchTerm
                    }
                    isSearching={this.state.isSearching}
                    placeholder={placeholder}
                    formatter={formatter}
                />
                {this.state.isOpen ? (
                    <Menu
                        noSearchTermRenderer={noSearchTermRenderer}
                        noResultsRenderer={noResultsRenderer}
                        warningRenderer={warningRenderer}
                        className="iwoca-select-container"
                        items={items}
                        optionRenderer={optionRenderer}
                        selectItem={this.selectItem}
                        header={helperText}
                        isSuccess={isSuccess}
                        searchTerm={this.state.searchTerm}
                        switchPosition={switchPosition}
                        switchText={manualSwitchText}
                        onHeaderClick={manualSwitch}
                        handleMouseDownOnMenu={this.handleMouseDownOnMenu}
                    />
                ) : null}
            </div>
        );
    }
}
